import type { GamificationMissionGroups, MissionsGroupVariants } from '../types';
import type { UserQuestDto } from '@/queries/userQuest/userQuest.schema';

const createEmptyMissionGroups = (): GamificationMissionGroups => ({
  welcome: {
    items: [],
  },
  fast: {
    items: [],
  },
  daily: {
    items: [],
  },
  weekly: {
    items: [],
  },
});

const frequencyToMissionGroup: Partial<Record<UserQuestDto['quest']['questTemplate']['recurrence']['freq'], MissionsGroupVariants>> = {
  daily: 'daily',
  fast: 'fast',
  weekly: 'weekly',
  once: 'welcome',
  welcome: 'welcome',
};

export const groupUserQuestsByMissionFrequency = (quests: UserQuestDto[] = []) => {
  const missionGroups = createEmptyMissionGroups();

  quests.forEach((quest) => {
    const recurrenceType = quest.quest.questTemplate.recurrenceType.toLowerCase();
    const frequency = quest.quest.questTemplate.recurrence.freq.toLowerCase();
    const variant = frequencyToMissionGroup[recurrenceType] ?? frequencyToMissionGroup[frequency];

    if (!variant) {
      return;
    }

    const nextUpdate = new Date(quest.endsAt).getTime();

    if (variant !== 'welcome' && Number.isFinite(nextUpdate) && (!missionGroups[variant].nextUpdate || nextUpdate < missionGroups[variant].nextUpdate)) {
      missionGroups[variant].nextUpdate = nextUpdate;
    }

    missionGroups[variant].items.push(quest);
  });

  return missionGroups;
};
